import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { ToolbarComponent } from './toolbar/toolbar.component';
import { BottomnavigationComponent } from './bottomnavigation/bottomnavigation.component';
import { NoInternetPopupComponent } from './no-internet-popup/no-internet-popup.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    FormsModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [
    ToolbarComponent,
    BottomnavigationComponent,
    NoInternetPopupComponent,
  ],
  declarations: [
    ToolbarComponent,
    BottomnavigationComponent,
    NoInternetPopupComponent,
  ],
  providers: [DatePipe],
})
export class ComponentsModule {}
